import '!ng-cache-loader!./MarketplaceItemBody.html';
import { v4 as uuid } from 'uuid';
import { marketplaceCreateSkillStateName } from '../list';
import UpgradePlanModalView from './upgradePlan/UpgradePlanModalView.html';
import { UpgradePlanModalController } from './upgradePlan/UpgradePlanModalController';
import './MarketplaceItem.scss';
const contactCardIdPrefix = 'contact-card-';
const marketplaceSolutionspackageSelected = 'marketplace-solutionspackage-selected';
const marketplaceSolutionsPackageUpgradeOpened = 'marketplace-solutionspackage-upgrade-opened';
var ContactSize;
(function (ContactSize) {
    ContactSize["Small"] = "small";
    ContactSize["Normal"] = "normal";
})(ContactSize || (ContactSize = {}));
export class MarketplaceItemController {
    static $inject = ['APPLICATION_DEFAULT_IMAGE', '$translate', 'MarketplaceService', '$state', 'SegmentService', 'AccountService2', 'ModalService'];
    constructor(APPLICATION_DEFAULT_IMAGE, $translate, MarketplaceService, $state, SegmentService, AccountService2, ModalService) {
        'ngInject';
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.$translate = $translate;
        this.MarketplaceService = MarketplaceService;
        this.$state = $state;
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.ModalService = ModalService;
        this.channels = [];
        this.contactCardId = `${contactCardIdPrefix}${uuid()}`;
        this.channels = this.contact.channels.split(',');
        this.init();
        this.loadPlan();
    }
    async init() {
        this.contactBy = await this.$translate('marketplace.contact.botByTake');
    }
    async loadPlan() {
        const plans = await this.MarketplaceService.getPlans();
        const indexPlanAccount = plans.findIndex(a => a.value == this.planAccount);
        const indexPlanSelect = plans.findIndex(a => a.value == (this.contact.plans ? this.contact.plans : '00892f5b-0404-40d5-8c1f-a57b7f709877'));
        if (indexPlanSelect > indexPlanAccount) {
            const namePlan = plans[indexPlanSelect].label;
            this.plan = namePlan.replace('Blip', '').replace('Free', '').replace('-', '');
            this.classPlan = 'plan-' + this.plan.toLowerCase().trim();
        }
        else {
            this.plan = '';
        }
    }
    $onChanges(changes) {
        const { size } = changes;
        this.onSizeChange(size);
        this.loadPlan();
        this.channels = this.contact.channels.split(',');
    }
    hasChange(change) {
        return change.previousValue !== change.currentValue;
    }
    async hasAccessPlan(planSelect, planAccount, ownerIdentity, accountIdentity) {
        if (!planSelect || ownerIdentity == accountIdentity) {
            return true;
        }
        const plans = await this.MarketplaceService.getPlans();
        const indexPlanSelect = plans.filter(a => a.value == planSelect)[0];
        const indexPlanAccount = plans.filter(a => a.value == planAccount)[0];
        return indexPlanSelect.order <= indexPlanAccount.order;
    }
    async gotoToMarketplaceDetails(marketplaceContactItem) {
        const account = await this.AccountService2.me();
        this.accountId = account.identity;
        this.packageName = marketplaceContactItem.name;
        if (await this.hasAccessPlan(marketplaceContactItem.plans, this.planAccount, marketplaceContactItem.ownerIdentity, this.accountId)) {
            this.MarketplaceService.saveTemplateBuffer(marketplaceContactItem);
            await this.createTracking(marketplaceSolutionspackageSelected, {
                clientId: this.accountId,
                packageName: this.packageName,
                tags: marketplaceContactItem.tags,
                channelsActive: marketplaceContactItem.channels,
            });
            this.$state.go(marketplaceCreateSkillStateName, { templateIdentity: marketplaceContactItem?.name });
        }
        else {
            const plans = await this.MarketplaceService.getPlans();
            const plan = plans.filter(a => a.value == marketplaceContactItem.plans)[0];
            this.planSelect = plan.label;
            this.labelPlanAccount = plans.filter(p => p.value == this.planAccount)[0].label;
            const logData = {
                clientId: this.accountId,
                packageName: this.packageName,
                templatePlan: plan.label,
                accountPlan: this.labelPlanAccount,
            };
            await this.ModalService.showModal({
                template: UpgradePlanModalView,
                controller: UpgradePlanModalController,
                controllerAs: '$ctrl',
                inputs: {
                    plan: this.plan,
                    logData: logData,
                },
            });
            await this.createTracking(marketplaceSolutionsPackageUpgradeOpened, logData);
        }
    }
    onSizeChange(size) {
        if (size && this.hasChange(size)) {
            if (!Object.values(ContactSize).includes(size.currentValue)) {
                this.size = ContactSize.Normal;
            }
        }
    }
    async createTracking(tracking, payload) {
        this.SegmentService.createTrack(tracking, payload);
    }
}
MarketplaceItemController.$inject = ['APPLICATION_DEFAULT_IMAGE', '$translate', 'MarketplaceService', '$state', 'SegmentService', 'AccountService2', 'ModalService'];
